<template>
  <section class="bg-hlt-light text-hlt">
    <div class="container-fluid-lg flex">
      <template
        v-for="{ name, title, isEnabled, variant } in features"
        :key="name"
      >
        <div v-if="isEnabled" class="flex justify-center w-full py-3">
          <span>{{ title }}</span>
          <span v-if="variant">, variant {{ variant.name }}</span>
        </div>
      </template>
    </div>
  </section>
</template>

<script setup lang="ts">
const nuxtApp = useNuxtApp()

const features = computed(() =>
  Object.values(nuxtApp.$unleash.features)
    .toSorted((a, b) => a.name.localeCompare(b.name))
    .map(({ name }) => toReactive(useFeature(name)))
    .filter((f) => f.markers.includes('show-in-test-bar')),
)
</script>
